import { Address } from "@raskrask-dk/raskrask-utils";
import {Next} from "./actions";

export type AddressActions = Next;
export const addressActions = [Next];
export type addrActions = typeof addressActions[number];

export interface IGetData {
  address: Address | undefined;
}
